<template>
  <div id="circular-chart"></div>
</template>

<script>
import ApexCharts from 'apexcharts'
export default {
  name: "CircularChart",
  data() {
    return {
       options : {
        chart: {
          height: 300,
          type: "radialBar",
        },
        series: [67, 84, 97, 61],
        plotOptions: {
          radialBar: {
            dataLabels: {
              total: {
                show: true,
                label: 'TOTAL'
              }
            }
          }
        },
        labels: ['TEAM A', 'TEAM B', 'TEAM C', 'TEAM D']
      },

    }
  },
  mounted() {
    new ApexCharts(document.querySelector("#circular-chart"), this.options).render();
  }
}
</script>

<style scoped>

</style>